import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Injector,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ItemsListRowItemDisplayValueComponent } from '../../components/items-list/list-row/list-row-item/display-value/display-value.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ItemsListRowItemBaseLink } from '../../components/items-list/list-row/list-row-item/list-row-item-base-link';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypesService } from '../../utilities/fi-services/object-types.service';
import { ISiteMapContentItem } from '@fi-shared/models/site-map';
import { SiteMapContentListData } from '@fi-app/site-map/site-map-content-list-data';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-site-map-content-name-column-link',
    templateUrl: './site-map-content-name-column-link.component.html',
    styleUrls: ['./site-map-content-name-column-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-site-map-content-name-column-link' },
    standalone: false,
})
export class SiteMapContentNameColumnLinkComponent extends ItemsListRowItemBaseLink implements AfterViewInit {
    @ViewChild('textContent', { static: false }) textContent: ElementRef;

    data: ISiteMapContentItem;
    private appText: AppTextService;
    private objectTypesService: ObjectTypesService;

    constructor(injector: Injector) {
        super(injector);
        this.appText = injector.get(AppTextService);
        this.objectTypesService = injector.get(ObjectTypesService);
        (this.ngModel as SiteMapContentListData).updateChildrenDataSets$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => this.updateText());
    }

    GetDisplayValue(data) {
        return ItemsListRowItemDisplayValueComponent.GetDisplayValue(data || this.data, this.head);
    }

    isTag() {
        return this.data.ObjectType == ObjectTypes.Tag;
    }

    ngAfterViewInit() {
        this.updateText();
    }

    updateText() {
        if (this.textContent) {
            this.textContent.nativeElement.innerText = this.GetDisplayValue(this.data);
        }
    }

    getTagClass() {
        return `tag-level-${this.data.Level}`;
    }
}
